import React from 'react';
import Downshift from 'downshift';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

import axios from 'axios';
import {Context} from "./ContextProvider";
import { useTranslation } from 'react-i18next';
import * as Logger from "./Logger";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        height: 250,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    inputRoot: {
        flexWrap: 'wrap',
    },
    inputInput: {
        width: 'auto',
        flexGrow: 1,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
}));

let requestTimeout;

function SelectBox(props) {
    let {state, dispatch} = React.useContext(Context);

    const {positionIndex, InputProps} = props;

    const { t, i18n } = useTranslation();

    const [suggestions, setSuggestions] = React.useState([]);
    const classes = useStyles();

    function inputOnChange(event) {
        if (!event.target.value) {
            return
        }
        fetchAdresses(event.target.value)
    }

    // Thype of osm nodes that are presented in autocomplete
    const acceptedOsmTypes = ["way"];

    function fetchAdresses(address) {

        if (requestTimeout) {
            clearTimeout(requestTimeout);
        }
        requestTimeout = setTimeout(function () {
            const addressURL = "https://nominatim.openstreetmap.org/search?limit=10&format=json&addressdetails=1&q=" +
                encodeURIComponent(address);
            Logger.log("querying for address: " + addressURL)
            axios.get(addressURL).then(response => {
                Logger.log("Got response");
                Logger.log(response);
                const sug = response.data.filter(row => {
                    return row.osm_type && acceptedOsmTypes.includes(row.osm_type)
                }).map(row => {
                        return {
                            label: row.address.city + " "/* + row.address.city_district + " " */ + row.address.road + " (" + row.osm_id + ")",
                            id: row.osm_id,
                            position: {lat: row.lat, lng: row.lon},
                        }
                    }
                );
                Logger.log(sug);
                setSuggestions(sug);
            })
            //TODO handle error scenario
        }, 1000);

    }

    function handleChange(selectedObject) {
        dispatch({type: positionIndex === "A" ? "setStartOnMap" : "setEndOnMap", payload: selectedObject.position,});
    }

    function itemToString(x) {
        return x ? x.label : "";
    }

    function renderInput(inputProps) {
        const {InputProps, classes, ref, ...other} = inputProps;

        return <TextField
            InputProps={{
                inputRef: ref,
                classes: {
                    root: classes.inputRoot,
                    input: classes.inputInput,
                },
                ...InputProps,
            }}
            value={positionIndex === "A" ? state.startDisplayName : state.endDisplayName}
            onChange={(event) => dispatch({
                type: positionIndex === "A" ? "setStartDisplayName" : "setEndDisplayName",
                payload: event.target.value
            })}
            {...other}
        />
    }

    return <Downshift inputValue={positionIndex === "A" ? state.startDisplayName : state.endDisplayName}
                      onInputValueChange={(value) => dispatch({
                          type: positionIndex === "A" ? "setStartDisplayName" : "setEndDisplayName",
                          payload: value
                      })}
                      itemToString={itemToString}
                      onChange={handleChange}>
        {({
              getInputProps,
              getItemProps,
              getMenuProps,
              highlightedIndex,
              inputValue,
              isOpen,
              selectedItem,
          }) => (
            <div className={classes.container}>
                {renderInput({
                    fullWidth: true,
                    classes,
                    InputProps: getInputProps({
                        placeholder: positionIndex === "A" ? t("Start") : t("Destination"),
                        onChange: inputOnChange,
                        ...InputProps
                    }),
                })}
                <div {...getMenuProps()}>
                    {isOpen ? (
                        <Paper className={classes.paper} square>
                            {suggestions.map((item, index) =>
                                <MenuItem
                                    {...getItemProps({
                                        item,
                                        index,
                                        isActive: highlightedIndex === index,
                                        isSelected: selectedItem === item
                                    })}

                                    key={item.label}
                                    component="div"
                                >
                                    {itemToString(item)}
                                </MenuItem>
                            )}
                        </Paper>
                    ) : null}
                </div>
            </div>
        )}
    </Downshift>

}

export default SelectBox;
